import { Node, Transforms, Editor, Element } from 'slate'
import { ElementWithType } from '../../../../../../utils/types';
import { JsonNode, INodeAttrs } from '../../../utils/types'
import { getSelectedCellsInATable } from '../table/utils/getSelectedCellsInATable';
import { getCurrentIndentLevel } from '../indentation/utils';

const formAttributes = (oldAttributes: { style: {} }, alignment: string, allowToggleOff: boolean = false) => {
    let redactorAttributes: Partial<INodeAttrs> = {}

    if (oldAttributes) {
        redactorAttributes = {
            ...redactorAttributes,
            ...oldAttributes["redactor-attributes"]
        }
    }

    const isAlignmentToggledOff = allowToggleOff && oldAttributes?.style?.["text-align"] === alignment
    const newStyle = { ...oldAttributes?.style }
    isAlignmentToggledOff ? delete newStyle["text-align"] : newStyle["text-align"] = alignment

    const elementAttribute = {
        attrs: {
            ...oldAttributes,
            style: newStyle,
            "redactor-attributes": redactorAttributes
        }
    }

    return elementAttribute;
}

export const alignNode = (editor, alignment) => {
    const { selection } = editor;
    if (selection === null) {
        return
    }

    const [table] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
            return n.type === 'table'
        },
        mode: 'lowest'
    })

    const cells = table && Array.from(getSelectedCellsInATable(editor, table[1]))
    if (cells) {
        if (cells.length === 1) {
            const [cell, cellPath] = cells[0]
            const [blockNode] = Editor.nodes(editor, {
                at: selection,
                match: (n: any) => Element.isElement(n) && (n as ElementWithType).type !== 'td' && (n as ElementWithType).type !== 'th' && (n as ElementWithType).type !== 'table',
                mode: 'lowest'
            })
            if (blockNode) {
                const elementAttribute = formAttributes((blockNode[0] as any).attrs, alignment, true)
                Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: selection })
            }
        } else {
            cells.forEach(([cell, cellPath]) => {
                const elementAttribute = formAttributes((cell as ElementWithType).attrs, alignment, true);
                Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: cellPath })
            });
        }
    }
    else {
        for (const [n, p] of Editor.nodes(editor, { at: selection })) {
            const node: JsonNode = n
            const path = p
            if (Element.isElement(node) && node.type !== 'doc' && node.type !== 'table') {
                // Don't apply alignment if element is indented
                const currentIndent = getCurrentIndentLevel(node as ElementWithType)
                if (currentIndent > 0) {
                    return
                }
                
                const oldAttributes: any = node.attrs
                let redactorAttributes: Partial<INodeAttrs> = {}

                if (oldAttributes) {
                    redactorAttributes = {
                        ...redactorAttributes,
                        ...oldAttributes["redactor-attributes"]
                    }
                }

                const [liNode] = Editor.nodes(editor, {
                    match: (n: any) => n.type === 'li',
                    at: selection,
                    mode: 'lowest'
                })

                const targetAttributes = liNode ? (liNode[0] as any).attrs : oldAttributes
                const isAlignmentToggledOff = targetAttributes?.style?.["text-align"] === alignment

                if (node.type === 'img' || node.type === 'reference') {
                    redactorAttributes.position = isAlignmentToggledOff ? 'none' : alignment
                }

                const newStyle = { ...targetAttributes?.style }
                isAlignmentToggledOff ? delete newStyle["text-align"] : newStyle["text-align"] = alignment

                const elementAttribute = {
                    attrs: {
                        ...(liNode ? targetAttributes : oldAttributes),
                        style: newStyle,
                        "redactor-attributes": liNode ? { ...targetAttributes?.["redactor-attributes"] } : redactorAttributes
                    }
                }

                if (liNode) {
                    Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: liNode[1] })
                    Transforms.select(editor, selection)
                    return
                }
                else Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: selection })
            }
            Transforms.select(editor, selection)
        }
    }

}


export const isNodeAligned = (editor, style) => {
    const selection = editor.selection;

    if (selection === null) {
        return false
    }

    const [node] = Editor.nodes(editor, { match: (n: any) => n?.attrs?.style?.["text-align"] })
    //@ts-ignore
    if (node) return node[0].attrs.style["text-align"] === style
    // else return style === 'left'
}

